import styled from 'styled-components'

const brandBlue = (p) => p.theme.colors.brand.blueOmint
const textSecondary = (p) => p.theme.colors.text.secondaryText

export const AutocompleteWrapper = styled.div`
  position: relative;
  width: ${(props) => props.$width || '100%'};
`

export const InputActions = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 2;
`

export const ClearButton = styled.button`
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${textSecondary};
  opacity: 0.6;
  transition: opacity 0.2s ease;
  pointer-events: auto;

  &:hover {
    opacity: 1;
  }
`

export const ChevronButton = styled.button`
  background: none;
  border: none;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${textSecondary};
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  pointer-events: auto;
  transition: transform 0.2s ease;
  transform: ${(props) => (props.$isOpen ? 'rotate(180deg)' : 'none')};
`
